<ng-template
	#loadingElement
	let-textKey>
	<div class="mfa-loading">
		<i class="fa-regular fa-loader fa-spin"></i>
		{{ textKey | translate }}
	</div>
</ng-template>

<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		<div class="public-center-wrapper">
			@if (isReady) {
				<div class="public-wrapper">
					<h2 class="public-msg">
						{{ mfaTitle }}
					</h2>
					@if (isFatalError | async) {
						<div class="public-wrapper-content simple-card">
							<eif-custom-button
								[text]="'mfa-verify.loginAgain' | translate"
								[fullWidth]="true"
								(click)="cancelLogin()"
								[class]="'mt-3 mb-3'">
							</eif-custom-button>
						</div>
					}
					<div class="public-wrapper-container">
						<!-- Show loading while showOtpVerificationLayout is processing -->
						@if (showOtpVerificationLayout | async) {
							<div class="public-wrapper-content simple-card">
								<ng-container>
									<div class="public-wrapper-content-title">
										{{ viewModel.MfaTypeTitle }}
									</div>
									<div
										class="public-wrapper-content-description"
										[innerHTML]="viewModel.MfaTypeDescription"></div>
									<form
										#form="ngForm"
										name="formLogin"
										class="public-form"
										(submit)="tryToSubmit($event)">
										<div
											class="group"
											(keydown)="onMfaKeydown($event)"
											(paste)="onMfaPaste($event)">
											<eif-custom-input
												#input0
												[align]="'center'"
												[maxlength]="'1'"
												[clearable]="false"
												[autoComplete]="'off'"
												[autoFocus]="true"
												(valueChange)="onMfaInputChange($event, 0)"
												(inputFocus)="onMfaInputFocus(0)">
											</eif-custom-input>
											<eif-custom-input
												#input1
												[align]="'center'"
												[maxlength]="'1'"
												[clearable]="false"
												[autoComplete]="'off'"
												(valueChange)="onMfaInputChange($event, 1)"
												(inputFocus)="onMfaInputFocus(1)">
											</eif-custom-input>
											<eif-custom-input
												#input2
												[align]="'center'"
												[maxlength]="'1'"
												[clearable]="false"
												[autoComplete]="'off'"
												(valueChange)="onMfaInputChange($event, 2)"
												(inputFocus)="onMfaInputFocus(2)">
											</eif-custom-input>
											<eif-custom-input
												#input3
												[align]="'center'"
												[maxlength]="'1'"
												[clearable]="false"
												[autoComplete]="'off'"
												(valueChange)="onMfaInputChange($event, 3)"
												(inputFocus)="onMfaInputFocus(3)">
											</eif-custom-input>
											<eif-custom-input
												#input4
												[align]="'center'"
												[maxlength]="'1'"
												[clearable]="false"
												[autoComplete]="'off'"
												(valueChange)="onMfaInputChange($event, 4)"
												(inputFocus)="onMfaInputFocus(4)">
											</eif-custom-input>
											<eif-custom-input
												#input5
												[align]="'center'"
												[maxlength]="'1'"
												[clearable]="false"
												[autoComplete]="'off'"
												(valueChange)="onMfaInputChange($event, 5)"
												(inputFocus)="onMfaInputFocus(5)">
											</eif-custom-input>
										</div>
										@if (invalidOrExpiredOtpVerificationCode) {
											<em class="mfa-error">{{ 'mfa-verify.invalidOrExpiredCode' | translate }}</em>
										}
									</form>
								</ng-container>
								<!-- Show loading while submitting MFA -->
								@if (isSubmittingMfa) {
									<ng-container *ngTemplateOutlet="loadingElement; context: { $implicit: 'mfa-verify.validating' }"></ng-container>
								}
							</div>
						} @else {
							<ng-container *ngTemplateOutlet="loadingElement; context: { $implicit: 'mfa-verify.loading' }"></ng-container>
						}
						<!-- Initial loading template -->
						@if (showOtpVerificationLayout | async) {
							<div class="public-footer">
								@if (viewModel?.HasOptionChooseOtherAuthenticators) {
									<a
										class="public-footer-link"
										(click)="chooseAnotherAuthenticator()">
										{{ 'mfa-verify.chooseAnotherAuthenticator' | translate }}
									</a>
								} @else {
									<!-- PLACEHOLDER FOR CONSTANT BUTTON POSITION -->
									<div></div>
								}
								@if (viewModel?.HasOptionRequestNewCode) {
									<eif-custom-button
										[text]="requestNewCodeButtonText"
										[tooltip]="requestNewCodeButtonTooltip"
										[color]="canRequestNewCode ? 'primary' : 'neutral'"
										[disabled]="!canRequestNewCode"
										(click)="requestNewCode()">
									</eif-custom-button>
								}
							</div>
						}
					</div>
				</div>
			} @else {
				<div class="mfa-loading">
					<i class="fa-regular fa-loader fa-spin"></i>
				</div>
			}
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
